function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import delay from 'lodash/delay';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
var _React_PureComponent;
class RevokeAccessModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProp) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProp.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            delay(()=>this.props.onCloseModal(), 150);
        }
    }
    onRevokeAccess() {
        const sharingRequest = get(this.props.formValues, 'contextData');
        this.props.onRevoke(sharingRequest);
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__actions row flex-wrap-reverse",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6 mt-4 mt-sm-0",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "quaternary",
                        labelMessage: messages.buttons.noKeepAccess,
                        className: "btn--block",
                        onClick: this.props.onCloseModal
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.revokeAccess,
                        className: "btn--block btn--filled",
                        isInProgress: this.props.isInProgress,
                        onClick: ()=>this.onRevokeAccess()
                    })
                })
            ]
        });
    }
    renderHcpDetails() {
        const hcp = get(this.props.formValues, 'contextData.hcp', {});
        return /*#__PURE__*/ _jsxs("b", {
            children: [
                hcp.firstName,
                " ",
                hcp.lastName
            ]
        });
    }
    renderPerson() {
        const clinic = get(this.props.formValues, 'contextData.clinic', {});
        const hcp = get(this.props.formValues, 'contextData.hcp', {});
        const name = hcp.lastName ? [
            hcp.firstName,
            hcp.lastName
        ] : clinic.name;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('row my-5 align-items-center', styles.person),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: hcp.avatar,
                        name: name,
                        className: styles.item__avatar,
                        imgClassName: styles.item__avatar__img,
                        initialsClassName: styles.item__avatar__initials
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: styles.person__name,
                            children: [
                                hcp.firstName,
                                " ",
                                hcp.lastName
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--small text--light",
                            children: clinic.name
                        })
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.REVOKE_ACCESS_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.revokeAccess,
            styleModifier: "md",
            onClose: this.props.shouldCloseOnlyViaActionButton ? null : this.props.onCloseModal,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.container,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.areYouSureToRevokeAccess), {
                            values: {
                                hcpDetails: this.renderHcpDetails()
                            }
                        })),
                        this.renderPerson()
                    ]
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
        };
    }
}
// static getDerivedStateFromProps(props, state) {
//   const { isInProgress, hasErrors, onCloseModal } = props;
//   if (state.isInProgress && !isInProgress && !hasErrors) {
//     onCloseModal();
//     return null;
//   }
//   return null;
// }
_define_property(RevokeAccessModal, "propTypes", {
    // Explicity props
    shouldCloseOnlyViaActionButton: PropTypes.bool,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    formValues: PropTypes.object,
    openModalId: PropTypes.string,
    // Implicit actions
    onRevoke: PropTypes.func,
    onCloseModal: PropTypes.func
});
const revokeAccessFormSelector = App.selectors.formSelector(constants.REVOKE_ACCESS_FORM);
const mapStateToProps = (state)=>({
        formValues: revokeAccessFormSelector(state),
        openModalId: App.selectors.modal(state),
        isInProgress: selectors.isRevokeSharingRequestInProgress(state),
        hasErrors: selectors.hasRevokeSharingRequestErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onRevoke: (sharingRequest)=>dispatch(actions.revokeSharingRequest(sharingRequest)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedRevokeAccessModal = connect(mapStateToProps, mapDispatchToProps)(RevokeAccessModal);
export default withStyles(styles)(ConnectedRevokeAccessModal);
